import { telegramAppLink } from "../lib/telegramGate";

/** Full-screen gate when the app is opened outside Telegram. */
export function TelegramOnly() {
  const link = telegramAppLink();

  return (
    <div className="app-shell tma-gate">
      <h1 className="brand">
        <span>Axiome Counter LP</span>
        <em>Только в Telegram</em>
      </h1>
      <p className="hero-copy">
        Это приложение работает как Telegram Mini App. Откройте его через бота в Telegram —
        так безопаснее и удобнее для подключения кошелька.
      </p>
      {link ? (
        <div className="cta-row">
          <a className="btn btn-primary" href={link} rel="noreferrer">
            Открыть в Telegram
          </a>
        </div>
      ) : (
        <p className="hint" style={{ textAlign: "center" }}>
          Запустите Mini App из вашего Telegram-бота.
        </p>
      )}
    </div>
  );
}
